export type DragIntentInput = {
  startX: number
  startY: number
  currentX: number
  currentY: number
  thresholdPx: number
}

export function exceedsDragIntent(input: DragIntentInput): boolean {
  const dx = input.currentX - input.startX
  const dy = input.currentY - input.startY
  return Math.hypot(dx, dy) > input.thresholdPx
}
